// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"sub_currentPeriodEnd":{"b":""},"sub_cancelAt":{"b":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function accountStatusV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "TERMINATED") {
    return $$enum;
  }
}

let accountStatusV5_fromString = accountStatusV5_decode;

function planHandleV5_decode($$enum) {
  if ($$enum === "COMPLIMENTARY" || $$enum === "PRO_YEARLY" || $$enum === "FREE" || $$enum === "PRO_TRIAL" || $$enum === "PRO_FREE" || $$enum === "PRO_QUARTERLY" || $$enum === "PRO_MONTHLY") {
    return $$enum;
  }
}

let planHandleV5_fromString = planHandleV5_decode;

function planInterval_decode($$enum) {
  if ($$enum === "INDEFINITE" || $$enum === "YEAR" || $$enum === "MONTH" || $$enum === "QUARTER") {
    return $$enum;
  }
}

let planInterval_fromString = planInterval_decode;

let Utils = {
  accountStatusV5_decode: accountStatusV5_decode,
  accountStatusV5_fromString: accountStatusV5_fromString,
  planHandleV5_decode: planHandleV5_decode,
  planHandleV5_fromString: planHandleV5_fromString,
  planInterval_decode: planInterval_decode,
  planInterval_fromString: planInterval_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BillingSettingsPageSubscription_accountV5",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountStatus",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "sub",
        "args": null,
        "concreteType": "AccountSubscriptionV5",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentPeriodEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelAt",
            "storageKey": null
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": "SubscriptionPlanV5",
              "kind": "LinkedField",
              "name": "plan",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "handle",
                    "storageKey": null
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "interval",
                    "storageKey": null
                  },
                  "action": "THROW"
                }
              ],
              "storageKey": null
            },
            "action": "THROW"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "AccountV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
